import { TopicChange } from "../../context/useDraft";

export interface TopicBadge {
  type: "live" | "new" | "has-updates";
  label: string;
  color: "green" | "blue";
}

export interface TopicWithBadges extends TopicChange {
  badges: {
    badges: TopicBadge[];
    isLive: boolean;
    isNew: boolean;
    hasUpdates: boolean;
    sectionBadges: {
      brief: TopicBadge | null;
      instructions: TopicBadge | null;
    };
  };
}

export const navigationViews = [
  "topics",
  "interactions",
  "pending-review",
  "sessions",
] as const;
export type NavigationView = (typeof navigationViews)[number];

export interface NavigationState {
  currentView: NavigationView;
  selectedTicketId: string | null;
  selectedInteractionId: string | null;
  canGoBack: boolean;
  isViewingTranscript: boolean;
}

export const topicToTopicWithBadges = (
  topicStatus: TopicChange
): TopicWithBadges => {
  return {
    ...topicStatus,
    badges: {
      isLive: topicStatus.isLive,
      isNew: topicStatus.isNew,
      hasUpdates: topicStatus.hasUpdates,
      badges: [
        ...(topicStatus.isLive
          ? [
              {
                type: "live" as const,
                label: "Live",
                color: "green" as const,
              },
            ]
          : []),
        ...(topicStatus.isNew
          ? [{ type: "new" as const, label: "New", color: "blue" as const }]
          : []),
        ...(topicStatus.hasUpdates
          ? [
              {
                type: "has-updates" as const,
                label: "Has Updates",
                color: "blue" as const,
              },
            ]
          : []),
      ],
      sectionBadges: {
        brief: topicStatus.hasUpdates
          ? {
              type: "has-updates" as const,
              label: "Has Updates",
              color: "blue" as const,
            }
          : null,
        instructions: topicStatus.hasUpdates
          ? {
              type: "has-updates" as const,
              label: "Has Updates",
              color: "blue" as const,
            }
          : null,
      },
    },
  };
};
